export default __webpack_public_path__ + "static/media/19.e41d7a78.jpg";